import Vue from 'vue'
import VueCookies from 'vue-cookies'
import store from '~/store/'

Vue.use(VueCookies)
/* eslint-disable */
export default {
  addProtocolToUrlIfMissing(url, secure = true) {
    const proto = secure ? 'https://' : 'http://'
    let u = url
    if (!url.startsWith('http')) {
      u = proto + url
    }
    return u
  },
  getUrlParameter(queryString, name) {
    const n = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
    const regex = new RegExp(`[\\?&]${n}=([^&#]*)`)
    const results = regex.exec(queryString)
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
  },

  getSession(eventData) {
    const response = eventData
    return response[0].Id
  },

  corsProxy() {
    const proxy = ''
    return proxy
  },

  isUrl(link) {
    if (!this.isString(link)) {
      return false
    }
    return link.startsWith('http')
  },
  getRouteWithDefaultParams(name, params = {}, query = {}) {
    const route = {
      name,
      params,
      query,
    }
    return this.appendDefaultParamsToRoute(route)
  },
  appendDefaultParamsToRoute(route) {
    const r = route
    const mergedParams = {
      instance: store.getters['instancesState/getInstanceUrlParam'],
      event: store.getters['instancesState/getEvent'],
      language: store.getters['instancesState/getLanguage'],
    }
    Object.assign(mergedParams, r.params)
    r.params = mergedParams
    return r
  },
  isObject(obj) {
    const type = typeof obj
    return type === 'function' || type === 'object' && !!obj
  },
  isString(str) {
    return Object.prototype.toString.call(str) === '[object String]'
  },
  queryString(params) {
    const queryString = Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&')
    return queryString
  },

  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i -= 1) { // TODO: check if for is really needed
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]
    }
  },

  getObjKey(key, obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return obj[key]
    }
    return null
  },

  setPageTitle(pageName) {
    const newPageTitels = store.getters['config/configForKey']('industry_config').config.PageTitles
    if (newPageTitels) {
      if (Object.prototype.hasOwnProperty.call(newPageTitels, pageName)) {
        return newPageTitels[pageName]
      }
    }
    return null
  },

}
